/**
 * cart-extras.js
 * Agrega dos cosas a la página /cart:
 * 1. Una barra de progreso hacia el envío gratis.
 * 2. Tarjetas de venta cruzada ("Añade un extra") con botón para agregar
 *    sin salir del carrito.
 *
 * Instalación:
 * 1. Panel de Shopify -> Tienda online -> Temas -> Ritual -> Editar código.
 * 2. Carpeta "Assets" -> Agregar un archivo nuevo -> nómbralo "cart-extras.js"
 *    y pega este contenido.
 * 3. En Layout/theme.liquid, justo antes de </body>, agrega:
 *    <script src="{{ 'cart-extras.js' | asset_url }}" defer></script>
 * 4. Ajusta FREE_SHIPPING_THRESHOLD y CROSS_SELL_PRODUCTS abajo si cambian.
 *
 * NOTA: los selectores para insertar el HTML en la página se basan en el
 * texto visible ("CART", "YOU MAY ALSO LIKE") para ser más resistentes a
 * cambios de clases internas del tema. Si algo no aparece, es probable que
 * el texto exacto de esos encabezados sea distinto — revisa el HTML real
 * del carrito y ajusta las funciones findHeadingByText() de abajo.
 */
(function () {
  if (window.location.pathname !== '/cart') return; // solo corre en la página del carrito

  const FREE_SHIPPING_THRESHOLD = 9500; // S/. 95.00 en centavos (formato de Shopify)

  const CROSS_SELL_PRODUCTS = [
    {
      variantId: 50935292100920,
      title: 'Caja Diablada',
      price: 'S/. 45.00',
      image: 'https://www.huaccaarcana.com/cdn/shop/files/caja_diablada_1.png?v=1754501519&width=300',
      url: '/products/caja-diablada?variant=50935292100920',
    },
    {
      variantId: 49242172850488,
      title: 'Caja Joyero',
      price: 'S/. 20.00',
      image: 'https://www.huaccaarcana.com/cdn/shop/files/cJA_PORTADA.png?v=1726280093&width=300',
      url: '/products/caja-joyero?variant=49242172850488',
    },
    {
      variantId: 49701042979128,
      title: 'Caja Joyero Ayacucho',
      price: 'S/. 40.00',
      image: 'https://www.huaccaarcana.com/cdn/shop/files/caja_ayuacu_ros.png?v=1754501479&width=300',
      url: '/products/caja-joyero-ayacucho?variant=49701042979128',
    },
  ];

  function formatMoney(cents) {
    return 'S/. ' + (cents / 100).toFixed(2);
  }

  function findHeadingByText(text) {
    const all = document.querySelectorAll('h1, h2, h3, h4');
    for (const el of all) {
      if (el.textContent.trim().toUpperCase().includes(text.toUpperCase())) {
        return el;
      }
    }
    return null;
  }

  // --- 1. Barra de progreso de envío gratis ---
  async function renderShippingBar() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    let bar = document.getElementById('cart-extras-shipping-bar');
    if (!bar) {
      const heading = findHeadingByText('CART');
      if (!heading) return;

      bar = document.createElement('div');
      bar.id = 'cart-extras-shipping-bar';
      bar.style.cssText = 'margin: 16px 0 24px; font-family: inherit;';
      heading.insertAdjacentElement('afterend', bar);
    }

    const remaining = FREE_SHIPPING_THRESHOLD - cart.total_price;
    const progress = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD) * 100);

    const message =
      remaining > 0
        ? `Te faltan <strong>${formatMoney(remaining)}</strong> para ENVÍO GRATIS`
        : `¡Tienes ENVÍO GRATIS! 🎉`;

    bar.innerHTML = `
      <p style="margin: 0 0 8px; font-size: 2 em;">${message}</p>
      <div style="background: #f0e0e0; border-radius: 999px; height: 8px; overflow: hidden;">
        <div style="background: #c1666b; height: 100%; width: ${progress}%; transition: width 0.3s ease;"></div>
      </div>
    `;
  }

  // --- 2. Venta cruzada ---
  async function renderCrossSell() {
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    const cartVariantIds = cart.items.map((item) => item.variant_id);

    let container = document.getElementById('cart-extras-cross-sell');
    if (!container) {
      const heading = findHeadingByText('YOU MAY ALSO LIKE') || findHeadingByText('TAMBIÉN TE PUEDE');
      if (!heading) return;

      container = document.createElement('div');
      container.id = 'cart-extras-cross-sell';
      container.style.cssText = 'margin: 24px 0; padding: 16px 0; border-top: 1px solid #eee;';
      heading.insertAdjacentElement('beforebegin', container);
    }

    const cardsHtml = CROSS_SELL_PRODUCTS.map((product) => {
      const alreadyInCart = cartVariantIds.includes(product.variantId);
      return `
        <div style="display: flex; flex-direction: column; gap: 8px; border: 1px solid #eee; border-radius: 10px; padding: 12px; min-width: 150px; flex-shrink: 0;">
          ${
            product.image
              ? `<img src="${product.image}" alt="${product.title}" style="width: 100%; height: 100px; object-fit: cover; border-radius: 8px;">`
              : `<div style="width: 100%; height: 100px; background: #f5f0f0; border-radius: 8px;"></div>`
          }
          <div>
            <p style="margin: 0; font-size: 0.9em; font-weight: 600; line-height: 1.3;">${product.title}</p>
            <p style="margin: 2px 0 0; font-size: 0.85em; opacity: 0.75;">${product.price}</p>
          </div>
          <button
            class="cart-extras-add-btn"
            data-variant-id="${product.variantId}"
            ${alreadyInCart ? 'disabled' : ''}
            style="border: none; background: ${alreadyInCart ? '#ccc' : '#c1666b'}; color: white; border-radius: 6px; padding: 10px 12px; font-size: 0.85em; cursor: ${alreadyInCart ? 'default' : 'pointer'}; width: 100%;"
          >
            ${alreadyInCart ? 'Agregado' : '+ Agregar'}
          </button>
        </div>
      `;
    }).join('');

    container.innerHTML = `
      <p style="margin: 0 0 12px; font-weight: 600; font-size: 1em;">Completa la presentación</p>
      <div style="display: flex; gap: 12px; overflow-x: auto; padding-bottom: 8px; -webkit-overflow-scrolling: touch;">${cardsHtml}</div>
    `;

    container.querySelectorAll('.cart-extras-add-btn').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.disabled) return;
        btn.disabled = true;
        btn.textContent = 'Agregando...';

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(btn.dataset.variantId), quantity: 1 }],
            }),
          });
          window.location.reload();
        } catch (err) {
          console.error('[cart-extras] Error al agregar producto:', err);
          btn.disabled = false;
          btn.textContent = '+ Agregar';
        }
      });
    });
  }

  function init() {
    renderShippingBar();
    renderCrossSell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // --- Volver a insertar si el tema borra nuestros elementos ---
  // Al agregar productos, esta tienda recarga la página completa (init() ya
  // lo cubre). Pero al QUITAR un producto o cambiar cantidades, el tema usa
  // una actualización parcial del DOM (morph.js / section-renderer.js) que
  // no conoce nuestros elementos y los elimina. Por eso reaccionamos también
  // a esos cambios explícitamente, y de respaldo con un MutationObserver.

  let reRenderTimeout = null;
  function scheduleReRender() {
    clearTimeout(reRenderTimeout);
    reRenderTimeout = setTimeout(() => {
      renderShippingBar();
      renderCrossSell();
    }, 400);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-remove], cart-remove-button, .cart-remove, [href*="/cart/change"]')) {
      scheduleReRender();
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('input[name="quantity"], input[name="updates[]"]')) {
      scheduleReRender();
    }
  });

  document.addEventListener('cart:build', scheduleReRender);

  // Respaldo genérico: si el contenedor de nuestra barra desaparece del DOM
  // por cualquier motivo no cubierto arriba, lo detectamos y reinsertamos.
  const observer = new MutationObserver((mutations) => {
    // Ignora mutaciones causadas por nuestros propios elementos, para
    // no entrar en un ciclo infinito de re-render.
    const relevant = mutations.some((m) => {
      return ![...m.addedNodes, ...m.removedNodes].every(
        (node) =>
          node.id === 'cart-extras-shipping-bar' ||
          node.id === 'cart-extras-cross-sell' ||
          (node.closest && node.closest('#cart-extras-shipping-bar, #cart-extras-cross-sell'))
      );
    });
    if (relevant) scheduleReRender();
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();